import { render, staticRenderFns } from "./ProductionApplicationPreview.vue?vue&type=template&id=fa70db5a&"
import script from "./ProductionApplicationPreview.vue?vue&type=script&lang=js&"
export * from "./ProductionApplicationPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProductionApplicationPreview.vue?vue&type=style&index=0&id=fa70db5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports